module.exports = __webpack_public_path__ + "bd0b1cdf615d96a062fddfcd3c14338f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-basketball-s.png
// module id = 1331
// module chunks = 0